<template>
  <div class="info-card">
    <div class="info-card-head">
      <span class="info-card-title">
        <v-icon small :color="brandColor" class="mr-1">store</v-icon>
        Dados do Estabelecimento
      </span>
      <v-btn
        v-if="!loading"
        small
        flat
        round
        class="info-card-edit"
        :style="{ color: brandColor }"
        to="profile"
      >Alterar</v-btn>
    </div>

    <div v-if="loading" class="pa-3">
      <div class="info-skeleton mb-2"></div>
      <div class="info-skeleton mb-2"></div>
      <div class="info-skeleton"></div>
    </div>

    <div v-else class="info-card-body">
      <div class="info-row">
        <span class="info-key">Nome Fantasia</span>
        <span class="info-val">{{ account.fantasy_name }}</span>
      </div>
      <div class="info-row">
        <span class="info-key">Nível</span>
        <span class="info-val">{{ account.partner ? onCaptalize($t(`partner.${account.partner}`)) : '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-key">Tipo de conta</span>
        <span class="info-val">{{ account.account_type ? onCaptalize($t(`account_type.${account.account_type}`)) : '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PartnerData",
  created() {
    this.$store.dispatch("account/getAccount");
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      partner: "account/partner",
      color: "account/color",
      loading: "account/loading",
    }),
    brandColor() {
      return this.color && String(this.color).startsWith("#") ? this.color : "#1976D2";
    },
  },
  data() {
    return {
      newAccount: {},
    };
  },
  watch: {
    account(newValues) {
      this.newAccount = newValues;
    },
  },
  methods: {
    onCaptalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style scoped>
.info-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 28px rgba(20, 30, 60, 0.08);
  height: 100%;
  overflow: hidden;
}
.info-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #eef1f6;
}
.info-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2733;
  display: inline-flex;
  align-items: center;
}
.info-card-edit {
  text-transform: none;
  font-weight: 600;
  margin: 0 !important;
}
.info-card-body {
  padding: 8px 22px 16px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f4f6f9;
}
.info-row:last-child {
  border-bottom: 0;
}
.info-key {
  font-size: 13px;
  color: #8a94a6;
  font-weight: 600;
}
.info-val {
  font-size: 14px;
  color: #1f2733;
  font-weight: 600;
  text-align: right;
}
.info-skeleton {
  height: 16px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
